export default "<div class=\"about-us\">\n  <div [innerHTML]=\"about|safeHtml\"></div>\n</div>\n"